import { render, staticRenderFns } from "./idp-config-diaog.vue?vue&type=template&id=72f5e910&scoped=true&"
import script from "./idp-config-diaog.vue?vue&type=script&lang=tsx&"
export * from "./idp-config-diaog.vue?vue&type=script&lang=tsx&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f5e910",
  null
  
)

export default component.exports